import { createFileRoute } from "@tanstack/react-router";

import { BaseEditCreateModal } from "@/components/_Modals/BaseEditCreateModal";
import { OrderForm } from "@/features/dashboard/pedidos/_components";

export const Route = createFileRoute("/_private/dashboard/_base/pedidos/cadastrar/modal")({
  component: ModalNewOrder
});

function ModalNewOrder() {
  return (
    <BaseEditCreateModal title="Cadastrar Pedido" from="/dashboard/pedidos/cadastrar">
      <OrderForm />
    </BaseEditCreateModal>
  );
}
